var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextFields = function SvgTextFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "text_fields_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#text_fields_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 20q-.625 0-1.062-.437A1.45 1.45 0 0 1 7 18.5V7H3.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 2 5.5q0-.625.438-1.062A1.45 1.45 0 0 1 3.5 4h10q.624 0 1.063.438Q15 4.874 15 5.5q0 .624-.437 1.063A1.45 1.45 0 0 1 13.5 7H10v11.5q0 .625-.437 1.063A1.45 1.45 0 0 1 8.5 20m9 0q-.625 0-1.062-.437A1.45 1.45 0 0 1 16 18.5V12h-1.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 13 10.5q0-.625.438-1.062A1.45 1.45 0 0 1 14.5 9h6q.625 0 1.063.438Q22 9.874 22 10.5q0 .624-.437 1.063A1.45 1.45 0 0 1 20.5 12H19v6.5q0 .625-.437 1.063A1.45 1.45 0 0 1 17.5 20"
  }))));
};
export default SvgTextFields;